'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$() {
  this.c5Q = null;
  this.c5R = false;
  this.c5O = null;
  this.c5P = false;
  this.c5S = null;
  this.c5T = false;
  this.c5U = null;
  this.c5V = false;
}
export { $c_Lpresto_types$DirectiveSelector$ as $c_Lpresto_types$DirectiveSelector$ };
$p = $c_Lpresto_types$DirectiveSelector$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$() {
}
export { $h_Lpresto_types$DirectiveSelector$ as $h_Lpresto_types$DirectiveSelector$ };
$h_Lpresto_types$DirectiveSelector$.prototype = $p;
$p.cHZ = (function() {
  if ((!this.c5R)) {
    this.c5Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c5R = true;
  }
  return this.c5Q;
});
$p.v7 = (function() {
  if ((!this.c5P)) {
    this.c5O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5P = true;
  }
  return this.c5O;
});
$p.cII = (function() {
  if ((!this.c5T)) {
    this.c5S = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5T = true;
  }
  return this.c5S;
});
$p.cIY = (function() {
  if ((!this.c5V)) {
    this.c5U = new $c_Lpresto_types$DirectiveSelector$$anon$66(this);
    this.c5V = true;
  }
  return this.c5U;
});
$p.a2Z = (function(str) {
  try {
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(document.querySelector(str));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
  return $x_1.sI();
});
var $d_Lpresto_types$DirectiveSelector$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$, "presto.types$DirectiveSelector$", ({
  ZE: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveSelector$ as $d_Lpresto_types$DirectiveSelector$ };
var $n_Lpresto_types$DirectiveSelector$;
function $m_Lpresto_types$DirectiveSelector$() {
  if ((!$n_Lpresto_types$DirectiveSelector$)) {
    $n_Lpresto_types$DirectiveSelector$ = new $c_Lpresto_types$DirectiveSelector$();
  }
  return $n_Lpresto_types$DirectiveSelector$;
}
export { $m_Lpresto_types$DirectiveSelector$ as $m_Lpresto_types$DirectiveSelector$ };
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$$anon$66(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveSelector$$anon$66 as $c_Lpresto_types$DirectiveSelector$$anon$66 };
$p = $c_Lpresto_types$DirectiveSelector$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$$anon$66;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$$anon$66() {
}
export { $h_Lpresto_types$DirectiveSelector$$anon$66 as $h_Lpresto_types$DirectiveSelector$$anon$66 };
$h_Lpresto_types$DirectiveSelector$$anon$66.prototype = $p;
$p.bn = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a7 : e$2);
    }
  }
});
$p.bN = (function(text) {
  return ($m_Lpresto_types$DirectiveSelector$().a2Z(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "CSS Selector is not valid")));
});
$p.bJ = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$DirectiveSelector$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$$anon$66, "presto.types$DirectiveSelector$$anon$66", ({
  ZF: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectiveSelector$$anon$66 as $d_Lpresto_types$DirectiveSelector$$anon$66 };
//# sourceMappingURL=presto.types$-Directive-Selector$.js.map
